import { render, staticRenderFns } from "./alislar.vue?vue&type=template&id=08aa7a70&scoped=true&"
import script from "./alislar.vue?vue&type=script&lang=js&"
export * from "./alislar.vue?vue&type=script&lang=js&"
import style0 from "./alislar.vue?vue&type=style&index=0&id=08aa7a70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aa7a70",
  null
  
)

export default component.exports